// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__m_-zc","label":"Labeled_label__3Yj4l","divider":"Labeled_divider__pLyb1"};